/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 28/03/22
 */

import React, { ReactElement, ReactNode } from 'react';
import { LoadingSpinner } from '@/components';

export interface StateDisplayProps<T> {
    loading: boolean;
    error: boolean;
    errorRender(): JSX.Element;
    render(data: T): JSX.Element;
    data?: T;
    fullscreenLoading?: boolean;
    renderLoading?: (spinner: ReactNode) => ReactElement;
}

const StateDisplay = <T,>(props: StateDisplayProps<T>) => {
    const { loading, error, data, fullscreenLoading, errorRender, render, renderLoading } = props;

    if (error) {
        return errorRender();
    } else if (!loading && data) {
        return render(data);
    } else {
        const spinner = <LoadingSpinner fullScreen={fullscreenLoading} />;
        if (renderLoading) {
            return renderLoading(spinner);
        }
        return spinner;
    }
};

export default StateDisplay;
